import { useMutation } from '@apollo/client';

import { CURRENT_EVENT } from '../../event/graphql/query/currentEventQuery.graphql';
import { STAFF_JOIN_BEDROOM } from '../graphql/mutation/staffJoinBedroomMutation.graphql';
import { EVENT_BEDROOMS } from '../graphql/query/eventBedroomsQuery.graphql';

export const useStaffJoinBedroomMutation = () => {
  const [mutate] = useMutation(STAFF_JOIN_BEDROOM);

  const staffJoinBedroom = (
    bedroomId: string,
    eventId: string,
    userId: string,
  ) => {
    mutate({
      variables: {
        bedroomId,
        eventId,
        userId,
      },
      refetchQueries: [EVENT_BEDROOMS, CURRENT_EVENT],
    });
  };

  return { staffJoinBedroom };
};
